function toggleClasses (scroll, parent) {
  if (scroll.scrollLeft <= 2) {
    parent.classList.add('is-scrolled')
  } else {
    parent.classList.remove('is-scrolled')
  }

  if (scroll.offsetWidth + scroll.scrollLeft === scroll.scrollWidth) {
    parent.classList.add('is-scrolled-end')
  } else {
    parent.classList.remove('is-scrolled-end')
  }
}

export function renderCategories () {
  const scroll = document.querySelector('.js-nav-categories-scroll')
  if (scroll) {
    const parent = scroll.parentNode

    toggleClasses(scroll, parent)

    scroll.addEventListener('scroll', (e) => {
      toggleClasses(scroll, parent)
    })
  }
}



// WEBPACK FOOTER //
// ./src/modules/categories.js